import React from "react";
import DriverGenericSkeleton from "./DriverGenericSkeleton";

function DriverDetailSkeleton() {
  return (
    <>
      <DriverGenericSkeleton />
    </>
  );
}

export default DriverDetailSkeleton;
